export default () => ({

    results: [],
    overlayVisible: false,
    clearSearchVisible: false,
    overlayImageUrl: '',
    homeTitle: '',
    searchInput: '',
    response: '',
    responseColour: '',

    init() {

        let ref = this;
        this.overlayVisible = false;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_homecare'
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((data) => {

            data.data.locations.forEach(function (post, index) {
                ref.results.push({
                    id: post.id,
                    title: post.title,
                    permalink: post.permalink,
                    post_type: post.post_type,
                    image: post.image,
                    image_alt: post.image_alt,
                    address: post.address,
                    telephone_one: post.telephone_one,
                    telephone_two: post.telephone_two,
                    featured_image_badge_enabled: post.featured_image_badge_enabled,
                    featured_image_badge_text: post.featured_image_badge_text,
                    latitude: post.latitude,
                    longitude: post.longitude,
                    distance: post.distance,
                    google_distance: post.google_distance,
                    google_duration: post.google_duration,
                    tags: post.tags,
                    home_care_covering_text: post.home_care_covering_text,
                    map_image: post.map_image
                })
            });

            google.maps.event.addDomListener(window, 'load', this.initMap());
        })
        .catch((error) => {
            console.error(error);
        });
    },

    initMap() {

        let ref = this;

        const map = new google.maps.Map(document.getElementById('homecaremap'), {
            zoom: 10,
            center: {
                lat: 51.900673080073005,
                lng: -0.6368104249999984
            }
        });

        let infoWindow = null;

        let latlngbounds = new google.maps.LatLngBounds();

        this.results.forEach(function (location, index) {
            infoWindow = new google.maps.InfoWindow();

            let marker = new google.maps.Marker({
                map,
                position: {
                    lat: Number(location.latitude),
                    lng: Number(location.longitude)
                },
                title: location.title,
                label: {
                    text: (index + 1).toString(),
                    color: 'white'
                },
                icon: location.type === 'care_home' ? '/wp-content/themes/healthcarehomes/assets/images/search/pin-01.png' : '/wp-content/themes/healthcarehomes/assets/images/search/pin-02.png',
                careHomeId: location.id,

                id: location.id,
                permalink: location.permalink,
                post_type: location.post_type,
                image: location.image,
                image_alt: location.image_alt,
                address: location.address,
                telephone_one: location.telephone_one,
                telephone_two: location.telephone_two,
                featured_image_badge_enabled: location.featured_image_badge_enabled,
                featured_image_badge_text: location.featured_image_badge_text,
                latitude: location.latitude,
                longitude: location.longitude,
                distance: location.distance,
                google_distance: location.google_distance,
                google_duration: location.google_duration,
                tags: location.tags,
                home_care_covering_text: location.home_care_covering_text,
                map_image: location.map_image
            });

            latlngbounds.extend(marker.position);

            marker.addListener('click', () => {
                ref.overlayVisible = true;
                ref.overlayImageUrl = '';
                ref.results = [];

                if (marker.map_image && marker.map_image.url) {
                    ref.overlayImageUrl = marker.map_image.url;
                }

                ref.results.push({
                    id: marker.id,
                    title: marker.title,
                    permalink: marker.permalink,
                    post_type: marker.post_type,
                    image: marker.image,
                    image_alt: marker.image_alt,
                    address: marker.address,
                    telephone_one: marker.telephone_one,
                    telephone_two: marker.telephone_two,
                    featured_image_badge_enabled: marker.featured_image_badge_enabled,
                    featured_image_badge_text: marker.featured_image_badge_text,
                    latitude: marker.latitude,
                    longitude: marker.longitude,
                    distance: marker.distance,
                    google_distance: marker.google_distance,
                    google_duration: marker.google_duration,
                    tags: marker.tags,
                    home_care_covering_text: marker.home_care_covering_text,
                    map_image: marker.map_image
                })

                ref.clearSearchVisible = true;
                ref.response = '';
                ref.responseColour = '';

            });
        });

        // Get the boundaries of the Map.
        let bounds = new google.maps.LatLngBounds();

        // Center map and adjust Zoom based on the position of all markers.
        map.setCenter(latlngbounds.getCenter());
        map.fitBounds(latlngbounds);

        this.results = [];

    },
    clearSearch() {
        this.overlayVisible = false;
        this.clearSearchVisible = false;
        this.response = '';
        this.responseColour = '';
        this.searchInput = '';
        this.results = [];
    },
    search() {

        const searchValue = this.searchInput;

        if (searchValue.length < 4) {
            this.clearSearch()
            this.response = 'Please enter at least 4 characters of your postcode';
            this.responseColour = 'text-rose-700';
            return;
        }

        this.results = [];
        let ref = this;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_homecare&postcode=' + this.searchInput
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((data) => {

            data.data.locations.forEach(function (post, index) {
                ref.results.push({
                    id: post.id,
                    title: post.title,
                    permalink: post.permalink,
                    post_type: post.post_type,
                    image: post.image,
                    image_alt: post.image_alt,
                    address: post.address,
                    telephone_one: post.telephone_one,
                    telephone_two: post.telephone_two,
                    featured_image_badge_enabled: post.featured_image_badge_enabled,
                    featured_image_badge_text: post.featured_image_badge_text,
                    latitude: post.latitude,
                    longitude: post.longitude,
                    distance: post.distance,
                    google_distance: post.google_distance,
                    google_duration: post.google_duration,
                    tags: post.tags,
                    home_care_covering_text: post.home_care_covering_text,
                    map_image: post.map_image
                })
            });

            this.response = data.data.response;
            this.responseColour = '';

            // google.maps.event.addDomListener(window, 'load', this.initMap());

            ref.clearSearchVisible = true;
            if (ref.results[0].map_image && ref.results[0].map_image.url) {
                this.overlayImageUrl = ref.results[0].map_image.url;
            }
            this.overlayVisible = true;
        })
        .catch((error) => {
            console.error(error);
        });
    }
})